import WorkspaceSelect from '../components/WorkspaceSelect';

const SelectWorkspacePage = () => {
    return <WorkspaceSelect />;
};

export default SelectWorkspacePage;

